import React from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useLayoutEffect } from "react";
import { useRef } from "react";
import styles from "./HyperAndHybrid.module.scss";
import phoneScreen from "../../img/hyperCasual/phoneScreen.png";
import gunHeadRunGif from "../../img/hyperCasual/gunHead.gif";
import pizzaGif from "../../img/hyperCasual/pizza.gif";
import hyperMan from "../../img/hyperCasual/hyperman.png";
import hybridMan from "../../img/hyperCasual/hybridman.png";
import clapEffect from "../../img/hyperCasual/clap.png";
import hifiveIcon from "../../img/hyperCasual/h-five.png";
const HyperAndHybrid = () => {
  const slider = useRef();
  const sectionRef = useRef();
  const hyperRef = useRef();
  const hyperManRef = useRef();
  const hybridManRef = useRef();
  const clapEffectRef = useRef();
  gsap.registerPlugin(ScrollTrigger);

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.matchMedia().add("(min-width:1921px)", () => {
        gsap.to(sectionRef.current, {
          xPercent: 0,
          scrollTrigger: {
            trigger: slider.current,
            start: "-15% top",
            end: () =>
              "+=" +
              document?.getElementById(styles.slide_container)?.offsetWidth /
                2.5,
            pin: true,
            scrub: true,
            invalidateOnRefresh: true,
            snap: 1,
            pinSpacing: "padding",
            markers: false,
          },
        });
      });
      gsap
        .matchMedia()
        .add("(min-width: 1441px) and (max-width: 1920px)", () => {
          gsap.to(sectionRef.current, {
            xPercent: -30,
            scrollTrigger: {
              trigger: slider.current,
              start: "top top",
              end: () =>
                "+=" +
                document?.getElementById(styles.slide_container)?.offsetWidth /
                  3.7,
              pin: true,
              scrub: true,
              invalidateOnRefresh: true,
              snap: 1,
              pinSpacing: "padding",
              markers: false,
            },
          });
        });

      gsap
        .matchMedia()
        .add("(min-width: 769px) and (max-width: 1440px)", () => {
          gsap.to(sectionRef.current, {
            xPercent: -30,
            ease: "none",
            columnGap: "50vw",
            scrollTrigger: {
              trigger: slider.current,
              end: () =>
                "+=" +
                document?.getElementById(styles.slide_container)?.offsetWidth /
                  3,
              pin: true,
              scrub: true,
              invalidateOnRefresh: true,
              snap: 1,
              pinSpacing: "padding",
            },
          });
        });
    }, slider);
    return () => ctx.revert();
  });
  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.matchMedia().add("(min-width:1921px)", () => {
        gsap.to(hyperManRef.current, {
          scrollTrigger: {
            trigger: hyperRef.current,
            // pin: true,
            start: "center center",
            scrub: true,
            // snap: 1,
            pinSpacing: false,
          },
          x: 95,
          duration: 4,
        });
      });
      gsap
        .matchMedia()
        .add("(min-width: 1441px) and (max-width: 1920px)", () => {
          gsap.to(hyperManRef.current, {
            scrollTrigger: {
              trigger: hyperRef.current,
              // pin: true,
              start: "center center",
              scrub: true,
              // snap: 1,
              pinSpacing: false,
            },
            x: 95,
            duration: 4,
          });
        });

      gsap
        .matchMedia()
        .add("(min-width: 769px) and (max-width: 1440px)", () => {
          gsap.to(hyperManRef.current, {
            scrollTrigger: {
              trigger: hyperRef.current,
              // pin: true,
              start: "center center",
              scrub: true,
              // snap: 1,
              pinSpacing: false,
            },
            x: "6vw",
            duration: 4,
          });
        });
    }, hyperManRef);
    return () => ctx.revert();
  });
  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.matchMedia().add("(min-width:1921px)", () => {
        gsap.to(hybridManRef.current, {
          scrollTrigger: {
            trigger: hyperRef.current,
            // pin: true,
            start: "center center",
            scrub: true,
            markers: false,
            pinSpacing: false,
          },
          x: -110,
          duration: 4,
        });
      });
      gsap
        .matchMedia()
        .add("(min-width: 1441px) and (max-width: 1920px)", () => {
          gsap.to(hybridManRef.current, {
            scrollTrigger: {
              trigger: hyperRef.current,
              // pin: true,
              start: "center center",
              scrub: true,
              markers: false,
              pinSpacing: false,
            },
            x: -110,
            duration: 4,
          });
        });
      gsap
        .matchMedia()
        .add("(min-width: 769px) and (max-width: 1440px)", () => {
          gsap.to(hybridManRef.current, {
            scrollTrigger: {
              trigger: hyperRef.current,
              // pin: true,
              start: "center center",
              scrub: true,
              markers: false,
              pinSpacing: false,
            },
            x: "-10vw",
            duration: 4,
          });
        });
    }, hybridManRef);
    return () => ctx.revert();
  });

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.matchMedia().add("(min-width:1921px)", () => {
        gsap.to(clapEffectRef.current, {
          opacity: 1,
          scrollTrigger: {
            trigger: hyperRef.current,
            start: "center center",
            // pin: true,
            scrub: true,
            // markers: true,
          },
          duration: 4,
        });
      });
      gsap
        .matchMedia()
        .add("(min-width: 1441px) and (max-width: 1920px)", () => {
          gsap.to(clapEffectRef.current, {
            opacity: 1,
            scrollTrigger: {
              trigger: hyperRef.current,
              start: "center center",
              // pin: true,
              scrub: true,
              // markers: true,
            },
            duration: 4,
          });
        });
      gsap
        .matchMedia()
        .add("(min-width: 769px) and (max-width: 1440px)", () => {
          gsap.to(clapEffectRef.current, {
            opacity: 1,
            scrollTrigger: {
              trigger: hyperRef.current,
              start: "center center",
              // pin: true,
              scrub: true,
              // markers: true,
            },
            duration: 4,
          });
        });
    }, clapEffectRef);
    return () => ctx.revert();
  });

  return (
    <div id={styles.slide_container} ref={slider}>
      <section className={styles.hypercasual_and_hybrid} ref={sectionRef}>
        <div className={styles.hypercasual} ref={hyperRef}>
          <div className={styles.hypercasual_text} data-content="Hyper Casual">
            Hyper Casual
          </div>
          <div className={styles.hyper_game_gif}>
            <img src={phoneScreen} alt="phoneScreen" />
            <img src={gunHeadRunGif} alt="gif" />
          </div>
        </div>
        <div className={styles.hybrid}>
          <div
            className={styles.hybridcasual_text}
            data-content="Hybrid Casual"
          >
            Hybrid Casual
          </div>
          <div className={styles.hybrid_game_gif}>
            <img src={phoneScreen} alt="phoneScreen" />
            <img src={pizzaGif} alt="gif" />
          </div>
        </div>
        <img
          className={styles.hyper_man}
          src={hyperMan}
          alt="hyperMan"
          ref={hyperManRef}
        />
        <img
          className={styles.hybrid_man}
          src={hybridMan}
          alt="hybridMan"
          ref={hybridManRef}
        />
        <img
          className={styles.clap}
          ref={clapEffectRef}
          src={clapEffect}
          alt="effect"
        />
        <img className={styles.hi_five_icon} alt="icon" src={hifiveIcon} />
      </section>
    </div>
  );
};

export default HyperAndHybrid;
